import { useCallback, useMemo, useState } from 'react'
import { useHistory, useLocation } from 'react-router-dom'

import { WinninAIReportContext } from './context'
import type { WinninAIReport } from './types'

export const WinninAIReportProvider = ({ children }) => {
  const [winninAIReport, setWinninAIReport] = useState<WinninAIReport>({} as WinninAIReport)

  const location = useLocation()
  const history = useHistory()

  const addWinninAIReportItem = (id, entity, providers, name) => {
    setWinninAIReport({ id, entity, ...(providers ? { outputProviders: providers } : {}), name })
  }

  const addWinninAIReportDetails = useMemo(() => {
    if (winninAIReport?.id && winninAIReport?.entity) {
      return (reportType, outputLanguage) => {
        setWinninAIReport(prevState => ({ ...prevState, reportType, outputLanguage }))
      }
    }
    return () => {}
  }, [winninAIReport?.entity, winninAIReport?.id])

  const resetWinninAIReport = useCallback(() => {
    const searchParams = new URLSearchParams(location.search)
    searchParams.delete('zaiReportEntityType')
    searchParams.delete('zaiReportEntityId')
    history.push({ search: searchParams.toString() })
    setWinninAIReport({} as WinninAIReport)
  }, [history, location.search])

  const backToPreviousStep = () => {
    setWinninAIReport(prevState => {
      const { reportType: _reportType, outputLanguage: _outputLanguage, ...rest } = prevState
      return rest
    })
  }

  const reportValues = useMemo(
    () => ({
      winninAIReport,
      addWinninAIReportItem,
      addWinninAIReportDetails,
      resetWinninAIReport,
      backToPreviousStep,
    }),
    [addWinninAIReportDetails, resetWinninAIReport, winninAIReport]
  )

  return <WinninAIReportContext.Provider value={reportValues}>{children}</WinninAIReportContext.Provider>
}
